import { render } from "./Waitlist.vue?vue&type=template&id=dbbb4c7a&scoped=true"
import script from "./Waitlist.vue?vue&type=script&lang=js"
export * from "./Waitlist.vue?vue&type=script&lang=js"

import "./Waitlist.vue?vue&type=style&index=0&id=dbbb4c7a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dbbb4c7a"]])

export default __exports__